/** Shared media helpers (size / time formatting, upload limits). */

/** "1.2 MB" / "380 KB". */
export function formatBytes(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/** Seconds (12.4) → "0:12". */
export function formatTime(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}

/* ---------- video uploads: max 10 MB, compressed automatically -------------- */

export const MAX_VIDEO_MB = 10;
export const MAX_VIDEO_BYTES = MAX_VIDEO_MB * 1024 * 1024;
export const VIDEO_ACCEPT = 'video/mp4,video/quicktime,video/x-m4v,video/webm,video/x-matroska,.mp4,.mov,.m4v,.webm,.mkv';
export const VIDEO_EXT_OK = /\.(mp4|mov|m4v|webm|mkv|avi|3gp|wmv)$/i;

/** Client-side guard before hitting the API (the API checks again). */
export function videoError(file) {
  if (!file) return 'Pick a video first';
  if (file.size > MAX_VIDEO_BYTES) {
    return `The video is ${formatBytes(file.size)} — the maximum is ${MAX_VIDEO_MB} MB`;
  }
  const name = (file.name || '').toLowerCase();
  if (file.type && !/^video\//.test(file.type) && !VIDEO_EXT_OK.test(name)) {
    return 'Unsupported video type (use MP4, MOV, M4V or WEBM)';
  }
  return '';
}

/** CSS aspect-ratio for a video/post image from its pixel size (defaults 16:9). */
export function ratioFromSize(width, height) {
  const w = Number(width) || 0;
  const h = Number(height) || 0;
  if (!w || !h) return '16 / 9';
  return `${w} / ${h}`;
}

/** True when the clip is portrait (a Reel). */
export const isVertical = (width, height) => Boolean(height && height > width);
